import { createApiRef } from '@backstage/core-plugin-api';

export interface ReportInfo {
  org: string;
  repo: string;
  version: string;
  lifecycle: string;
  ownerDisplayName: string;
}

export interface PatternMetrics {
  adoptionDetails: ReportInfo[];
  currentVersion: string;
  chartData: PatternAdoptionChartData[];
}

export const patternRef = createApiRef<PatternApi>({
  id: 'plugin.api-pattern.service',
});

export interface PatternApi {
  getPatternMetricsResults: (
    patternVersionField: string,
    organization: string,
    repo: string,
  ) => Promise<PatternMetrics>;
}
